declare var $: any;

export class Notification {

	public notify(message: string, options: any, icon: string = "ti-bell") {

		$.notify({
			icon: icon,
			message: message
		}, options);
	};
}



// WEBPACK FOOTER //
// ./src/app/shared/notification/notification.ts